<style scoped lang="scss">
@import '$vars';
.loading::after {
  border: 3px solid #fff;
  border-radius: 50%;
  border-right-color: transparent;
  border-top-color: transparent;
}
.loading {
  padding: auto 3em;
  >span {
    visibility: hidden;
  }
}
button {
  margin: auto 0 auto auto;
  height: 100%;
  background: #4285F4;
  border: 2px solid #4285F4;
  padding: 0;
  cursor: pointer;
  >span {
    display: flex;
    align-items: center;
    span {
      color: white;
      padding: 0 10px 3px
    }
  }
}
figure {
  height: 100%;
  background: #fff;
  border-right: 2px solid #4285F4;
  padding: 5px
}
svg {
  width: 20px;
  .st0{fill:#4285F4;}
  .st1{fill:#34A853;}
  .st2{fill:#FBBC04;}
  .st3{fill:#EA4335;}

}
</style>

<template>
  <button :disabled="sending || disabled" :type="type || 'submit'" @click="click()">
    <span :class="sending ? 'loading' : ''">
      <figure>
        <svg version="1.1" id="Livello_1" xmlns:x="&ns_extend;" xmlns:i="&ns_ai;" xmlns:graph="&ns_graphs;"
          xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 533.5 544.3"
          style="enable-background:new 0 0 533.5 544.3;" xml:space="preserve">
        <metadata>
          <sfw>
            <slices></slices>
            <sliceSourceBounds  bottomLeftOrigin="true" height="544.3" width="533.5" x="0.1" y="110.1"></sliceSourceBounds>
          </sfw>
        </metadata>
        <g>
          <path class="st0" d="M533.5,278.4c0-18.5-1.5-37.1-4.7-55.3H272.1v104.8h147c-6.1,33.8-25.7,63.7-54.4,82.7v68h87.7
            C503.9,431.2,533.5,361.2,533.5,278.4z"/>
          <path class="st1" d="M272.1,544.3c73.4,0,135.3-24.1,180.4-65.7l-87.7-68c-24.4,16.6-55.9,26-92.6,26c-71,0-131.2-47.9-152.8-112.3
            H28.9v70.1C75.1,486.3,169.2,544.3,272.1,544.3z"/>
          <path class="st2" d="M119.3,324.3c-11.4-33.8-11.4-70.4,0-104.2V150H28.9c-38.6,76.9-38.6,167.5,0,244.4L119.3,324.3z"/>
          <path class="st3" d="M272.1,107.7c38.8-0.6,76.3,14,104.4,40.8l0,0l77.7-77.7C405,24.6,339.7-0.8,272.1,0C169.2,0,75.1,58,28.9,150
            l90.4,70.1C140.8,155.6,201.1,107.7,272.1,107.7z"/>
        </g>
        </svg>
      </figure>

      <span>{{text}}</span>
    </span>
  </button>
</template>

<script>
export default {
  props: [
    'text',
    'sending',
    'size',
    'disabled',
    'type',
    'color'
  ],
  methods: {
    click () {
      this.$emit('click', true)
    }
  }
}
</script>
